import { request } from "./http";
import type {
  ConversationSearchResponse,
  MessagesResponse,
  SendMessageResponse,
} from "../types/whatsapp";

export function searchConversation(
  phone: string,
  token: string | null,
): Promise<ConversationSearchResponse> {
  const encoded = encodeURIComponent(phone);
  return request<ConversationSearchResponse>(
    `/api/admin/whatsapp/conversations/search?phone=${encoded}`,
    { token },
  );
}

export function getMessages(
  conversationId: string,
  token: string | null,
  limit = 100,
  offset = 0,
): Promise<MessagesResponse> {
  return request<MessagesResponse>(
    `/api/admin/whatsapp/conversations/${conversationId}/messages?limit=${limit}&offset=${offset}`,
    { token },
  );
}

export function sendMessage(
  conversationId: string,
  body: string,
  token: string | null,
): Promise<SendMessageResponse> {
  return request<SendMessageResponse>(
    `/api/admin/whatsapp/conversations/${conversationId}/messages`,
    { method: "POST", body: { body }, token },
  );
}
